import { render, staticRenderFns } from "./scholarcyList.vue?vue&type=template&id=474947db&scoped=true"
import script from "./scholarcyList.vue?vue&type=script&lang=js"
export * from "./scholarcyList.vue?vue&type=script&lang=js"
import style0 from "./scholarcyList.vue?vue&type=style&index=0&id=474947db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474947db",
  null
  
)

export default component.exports